import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify';
import store from './store'
import router from './router'
import 'material-design-icons-iconfont/dist/material-design-icons.css'


Vue.config.productionTip = false
Vue.config.performance = true


new Vue({
  vuetify,
  store,
  router,
  render: h => h(App)
}).$mount('#app')
